/**
 * Extension of FluidKeyObject type to provide a strongly
 * typed keyed object, where key is the dataPath the
 * values apply to in a datasource.
 */
export type FilterSetValue = { normalised: string; display: string };
export type DatasourceItem = any;

// ================================================================ //
// -- Filters

/**
 * Filter Constants
 */
export const BLANK_FILTER_LABEL = '(no value)';
export const BLANK_FILTER_ID_VALUE = 'noValue';
export const COLUMN_FILTER_TITLE_DEFAULT = 'Column Filters';
export const FILTER_BY_DATE_DEFAULT = 'Filter by Date';
export const SEARCH_FILTER_DEFAULT = 'Search';
export const FILTER_TYPE_DELIM = '__';
export const COLUMN_VISIBILITY = 'column-visibility';
export const DEFAULT_COMPACT_SECTION_HEIGHT = '200px';
export const SLOTTED_FILTER = 'slot';
/**
 * Creates a unique filter set id.
 * @param dataPath
 * @param type
 */
export const FILTER_SET_ID = (dataPath: string, type = 'column') =>
  `${dataPath}_filter${FILTER_TYPE_DELIM}${type}`;

/**
 * Creates a unique filter toggle id.
 * @param dataPath
 * @param value
 */
export const FILTER_TOGGLE_ID = (dataPath: string, value: string) =>
  `${dataPath}_${STRING_FROM(value).replace(/ /g, '_')}`;

/**
 * Turns any given value into a string by surrounding with
 * string delimiters.
 * @param value
 */
export const STRING_FROM = (value: any): string => `${value}`;
